
const WaterTags = ["water", "cache"];
const TrailMagicTags = ["magic"];
const ConditionsTags = ["haz", "cond"];
const ConnectivityTags = ["service"];
const CampingTags = ["camp"];
const LostNFoundTags = ["lost"];

const fileWater = "water"
const fileTrailMagic = "magic"
const fileConditions = "conditions"
const fileCamping = "camping"
const fileLostNFound = "lost_found"
const fileConnectivity = "connectivity"

export enum CommentCategory {
  Water = "water",                // water, cache 
  TrailMagic = "trailMagic",      // magic
  Conditions = "conditions",      // haz, cond
  Connectivity = "connectivity",  // service, update
  Camping = "camping",            // camp
  LostNFound = "lostNFound",      // lost
  Uncategorized = "uncategorized"
}

export const getCommentCategoryIcon = (categoryTag: string): string => {
    const category = getCommentCategoryType(categoryTag);
    let fileName = "";
    switch(category){
        case CommentCategory.Water: 
            fileName = fileWater;
            break;
        case CommentCategory.TrailMagic:
            fileName = fileTrailMagic;
            break;
        case CommentCategory.Conditions:
            fileName = fileConditions;
            break;
        case CommentCategory.Connectivity:
            fileName = fileConnectivity;
            break;
        case CommentCategory.Camping:
            fileName = fileCamping;
            break;
        case CommentCategory.LostNFound:
            fileName = fileLostNFound;
            break;
    }
    if (fileName !== ""){
        return `/comments/${fileName}.svg`;
    }
    return "";
}

export const getCommentCategoryType = (categoryTag: string): CommentCategory => {
    if (WaterTags.includes(categoryTag)){
        return CommentCategory.Water;
    }
    if (TrailMagicTags.includes(categoryTag)){
        return CommentCategory.TrailMagic;
    }
    if (ConditionsTags.includes(categoryTag)){
        return CommentCategory.Conditions;
    }
    if (ConnectivityTags.includes(categoryTag)){
        return CommentCategory.Connectivity;
    }
    if (CampingTags.includes(categoryTag)){
        return CommentCategory.Camping;
    }
    if (LostNFoundTags.includes(categoryTag)){
        return CommentCategory.LostNFound;
    }
    return CommentCategory.Uncategorized;
}

export const getCommentCategoryTags = (categoryType: CommentCategory): string[] => {
    switch(categoryType){
        case CommentCategory.Water:
            return WaterTags;
        case CommentCategory.TrailMagic:
            return TrailMagicTags;
        case CommentCategory.Conditions:
            return ConditionsTags;
        case CommentCategory.Connectivity:
            return ConnectivityTags;
        case CommentCategory.Camping:
            return CampingTags;
        case CommentCategory.LostNFound:
            return LostNFoundTags;
    }
    return [];
}

export const getWaypointIcon = (fileName: string): string => {
    return `/waypoints/${fileName}.svg`;
}
